import { request } from '@umijs/max';

export async function queryCurrentUser() {
  return request('user');
}

/** đăng nhập POST /api/login/account */
export async function apiLogin(body: any) {
  return request('user/login', {
    method: 'POST',
    data: body
  });
}

export const apiVerifyLogin = (token: string) => request(`user/verify-login/${token}`);

export const apiMyClasslist = (params: any) => request(`user/my-class-list`, { params });

export const apiGetTotalMyResult = () => request(`user/my-total-result`);

export async function apiUserAnswerCount() {
  return request('user/total-answer');
}

export async function apiMyNotifications(params: any) {
    return request(`user/my-notifications`, { params });
}

export async function apiUserNotificationDelete(id: string) {
    return request(`https://dhhp.edu.vn/api/user/notification/${id}`, {
        method: 'DELETE'
    });
}

export async function apiUserClassExamVersions(params: any) {
  return request(`user/class-exam-versions`, { params });
}

export async function apiUserProfile() {
  return request('https://identity.dhhp.edu.vn/user');
}

export async function apiMyInvoices(params: any) {
    return request(`user/invoices`, { params });
}

export async function apiMyExamRegistrations(params: any) {
    return request(`user/exam-registrations`, { params });
}

export async function apiUserRegistrationExamCancel(data: { id: string; note: string }) {
    return request(`user/registration/exam/cancel`, {
        method: 'POST',
        data
    });
}